import { useMutation } from '@tanstack/react-query';
import { businessAreasRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';

export const useDeleteBusinessArea = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id: number) =>
    businessAreasRepo.deleteBusinessArea(id),
  );
